var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.items.length)?_c('x-data-table',{attrs:{"caption":"Прочее оборудование","headers":_vm.headers,"items":_vm.items,"hide-default-footer":true}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }